import React from "react";

// Non-sortable columns render plain text (unchanged).
// Numeric columns opt in via `enableSorting` in the column def; for those we
// render a clickable header that cycles none → asc → desc, with a stacked
// up/down chevron that highlights the active direction.
function ColumnHeader({ column, title, className = "" }) {
  const canSort = typeof column?.getCanSort === "function" && column.getCanSort();

  if (!canSort) {
    return (
      <div className={`text-data-table ${className}`} style={{ fontWeight: 500 }}>
        {title}
      </div>
    );
  }

  const sorted = column.getIsSorted(); // false | "asc" | "desc"

  return (
    <button
      type="button"
      className={`text-data-table th-sort${sorted ? " th-sort--active" : ""} ${className}`}
      style={{ fontWeight: 500 }}
      onClick={column.getToggleSortingHandler()}
      title="Sort by this column"
    >
      <span className="th-sort__label">{title}</span>
      <span className={`th-sort__ind th-sort__ind--${sorted || "none"}`} aria-hidden="true">
        <svg className="th-sort__up" width="8" height="5" viewBox="0 0 8 5" fill="none">
          <path d="M1 4L4 1L7 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <svg className="th-sort__down" width="8" height="5" viewBox="0 0 8 5" fill="none">
          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </button>
  );
}

export default ColumnHeader;
